/**
 * State used in rendering ToolbarButton
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
